export const frontmatter = {
    "draft": true,
    "title": "Get started",
    "sidebar_group": "quickstart",
    "sidebar_group_label": "Quickstart",
    "sidebar_label": "Get started",
    "sidebar_order": 2
}

export const toc = []